<template>
  <v-select
    @change="changed"
    v-model="newValue"
    :items="choices"
    :label="required ? label + $t('cabledesign.required') : label"
    item-value="id"
    item-text="value"
    v-if="readonly != 'RO'"
    :readonly="readonly == 'WR' ? false : true"
    :clearable="clearable"
    class="mt-0 pt-0"
    :required="required"
  >
  </v-select>
  <div v-else>
    {{ label }}: {{ value != null ? getValue : $t('cabledesign.notFilled') }}
  </div>
</template>

<script>
export default {
  props: ["value", "choices", "label", "readonly", "clearable", "required"],
  data() {
    return {
      newValue: this.value
    };
  },
  watch: {
    value() {
      this.newValue = this.value;
    }
  },
  computed: {
    getValue() {
      let val = this.choices.find(c => c.id == this.value)
      return val != undefined ? val.value : null
    }
  },
  methods: {
    changed() {
      this.$emit("change", this.newValue);
    }
  }
};
</script>